const mapa1 = 
{
brasil: {
  regionName: 'Brasil',
  proportion: 100,
  resultados: [
    {
      percentage: 80,
      number: '3.017.668',
    },
    {
      percentage: 70,
      number: '37.501',
    },
    {
      percentage: 60,
      number: '12,4',
        
    }
  ]
},
north: {
  regionName: 'Norte',
  proportion: 100,
  resultados: [
    {
      percentage: 26,
      number: '320.924',
       
    },
    {
      percentage: 35,
      number: '4.874',
       
    },
    {
      percentage: 100,
      number: '15,2',
       
    }
  ]
},
south: {
  regionName: 'Sul',
  proportion: 100,
  resultados: [
    {
      percentage: 33,
      number: '406.529',
       
    },
    {
      percentage: 31,
      number: '4.224',
       
    },
    {
      percentage: 66,
      number: '10,4',
       
    }
  ]
},
southeast: {
  regionName: 'Sudeste',
  proportion: 95,
  resultados: [
    {
      percentage: 100,
      number: '1.196.232',
       
    },
    {
      percentage: 100,
      number: '13.547',
       
    },
    {
      percentage: 73,
      number: '11,3',
       
    }
  ]
},
northeast: {
  regionName: 'Nordeste',
  proportion: 95,
  resultados: [
    {
      percentage: 70,
      number: '846.374',
       
    },
    {
      percentage: 87,
      number: '11.825',
       
    },
    {
      percentage: 93,
      number: '14,0',
       
    }
  ]
},
center: {
  regionName: 'Centro-oeste',
  proportion: 95,
  resultados: [
    {
      percentage: 22,
      number: '274.609',
       
    },
    {
      percentage: 22,
      number: '3.031',
       
    },
    {
      percentage: 80,
      number: '12,2',
       
    }
  ]
},
}

const mapa2 = 
{
brasil: {
  regionName: 'Brasil',
  proportion: 100,
  resultados: [
    {
      percentage: 30,
      number: '3.017.668',
        
    },
    {
      percentage: 35,
      number: '1.738',
        
    },
    {
      percentage: 60,
      number: '57,6',
        
    }
  ]
},
north: {
  regionName: 'Norte',
  proportion: 100,
  resultados: [
    {
      percentage: 26,
      number: '320.924',
       
    },
    {
      percentage: 33,
      number: 214,
       
    },
    {
      percentage: 97,
      number: '66,7',
       
    }
  ]
},
south: {
  regionName: 'Sul',
  proportion: 90,
  resultados: [
    {
      percentage: 38,
      number: '406.529',
       
    },
    {
      percentage: 26,
      number: 166,
       
    },
    {
      percentage: 58,
      number: '40,8',
       
    }
  ]
},
southeast: {
  regionName: 'Sudeste',
  proportion: 100,
  resultados: [
    {
      percentage: 100,
      number: '1.196.232',
       
    },
    {
      percentage: 100,
      number: 631,
       
    },
    {
      percentage: 77,
      number: '52,7',
       
    }
  ]
},
northeast: {
  regionName: 'Nordeste',
  proportion: 100,
  resultados: [
    {
      percentage: 70,
      number: '846.374',
    },
    {
      percentage: 92,
      number: 580,
    },
    {
      percentage: 100,
      number: '68,5',
    }
  ]
},
center: {
  regionName: 'Centro-oeste',
  proportion: 100,
  resultados: [
    {
      percentage: 18,
      number: '274.609',
       
    },
    {
      percentage: 23,
      number: 147,
       
    },
    {
      percentage: 86,
      number: '59,4',
       
    }
  ]
},
}

const mapa3 = 
{
brasil: {
  regionName: 'Brasil',
  proportion: 100,
  resultados: [
    {
      percentage: 30,
      number: '3.050.662',
        
    },
    {
      percentage: 35,
      number: '32.994',
    },
    {
      percentage: 60,
      number: '10,8',
    }
  ]
},
north: {
  regionName: 'Norte',
  proportion: 80,
  resultados: [
    {
      percentage: 26,
      number: '324.554',
       
    },
    {
      percentage: 25,
      number: '3.630',
       
    },
    {
      percentage: 84,
      number: '11,2',
       
    }
  ]
},
south: {
  regionName: 'Sul',
  proportion: 95,
  resultados: [
    {
      percentage: 33,
      number: '409.917',
    },
    {
      percentage: 25,
      number: '3.388',
       
    },
    {
      percentage: 61,
      number: '8,3',
       
    }
  ]
},
southeast: {
  regionName: 'Sudeste',
  proportion: 100,
  resultados: [
    {
      percentage: 100,
      number: '1.208.424',
       
    },
    {
      percentage: 100,
      number: '12.192',
       
    },
    {
      percentage: 76,
      number: '10,1',
       
    }
  ]
},
northeast: {
  regionName: 'Nordeste',
  proportion: 100,
  resultados: [
    {
      percentage: 70,
      number: '857.726',
       
    },
    {
      percentage: 91,
      number: '11.352',
       
    },
    {
      percentage: 100,
      number: '13,2',
       
    }
  ]
},
center: {
  regionName: 'Centro-oeste',
  proportion: 80,
  resultados: [
    {
      percentage: 22,
      number: '277.041',
       
    },
    {
      percentage: 16,
      number: '2.432',
       
    },
    {
      percentage: 61,
      number: '8,8',
       
    }
  ]
},
}

export { mapa1, mapa2, mapa3}